import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
// import PrivateRoute from '../PrivateRoute/PrivateRoute';
import Onboarding from './Onboarding/Onboarding';
import Forum from './Forum';

const ForumRouter = ({ url }) => {
  return (
    <Switch>
      {/* <PrivateRoute path={`${url}/onboarding`} component={Onboarding} /> */}
      <Route path={`${url}/onboarding/`} component={Onboarding} />
      <Route path={`${url}/:to/`} component={Forum} />
      <Route path={`${url}/`} component={Forum} />
    </Switch>
  );
};

export default connect(
  (_, { match: { url } }) => ({ url }),
  {}
)(ForumRouter);
